import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useTIN } from '@src/state/taxInformation';

export const TINInput = ({ form, handleSubmit }) => {
  const format = (value) => {
    const newValue = value.slice(0, 9);
    return newValue;
  };

  const { setTIN } = useTIN.actions();

  const handleSearch = (e) => {
    form.validate('search.TINNumber');
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleOnChange = (value) => {
    form.validate('search.TINNumber');
    setTIN(form.getValues('search.TINNumber'));
  };

  const handleOnClear = () => {
    handleSearch('');
  };

  useEffect(() => {
    form.setValue('search.TINNumber', '');
  }, []);

  return (
    <FormProvider state={form}>
      <TextInput
        id="tininput-input"
        label="Tax ID Number (TIN)"
        model="search.TINNumber"
        aria-label="type here to perform a Access Code search"
        mask="numeric"
        maskConfig={{ format, allowNegative: false, decimalSeparator: false }}
        validators={{
          required: 'Please enter a valid TIN.',
          minLength: {
            value: 9,
            message: 'Please enter a valid TIN.',
          },
        }}
        css={{
          'abyss-text-input-label': {
            fontWeight: 600,
            fontSize: '14px',
          },
          'abyss-text-input': {
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
            },
            '[type=number]': {
              '-webkit-appearance': 'none',
            },
            '[type="number"]': {
              '-webkit-appearance': 'textfield',
              '-moz-appearance': 'textfield',
              appearance: 'textfield',
            },
          },
        }}
        onChange={(e) => {
          return handleOnChange(e.target.value);
        }}
        onKeyDown={handleSearch}
        onClear={handleOnClear}
        isClearable
      />
    </FormProvider>
  );
};

TINInput.propTypes = {
  form: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

TINInput.defaultProps = {};
